import api from '../../plugins/api';

// POST /crm/cars/clearStock — полная очистка стока приложения (только админ):
// снимает с публикации все forApp-машины (forApp = false + удаление их
// dealers_stock). Оффлайн-машины брокера не затрагиваются
const clearStock = () => {
  return api.post('/api/crm/cars/clearStock');
};

export default clearStock;
